module.exports = __webpack_public_path__ + "static/SharpSansNo1-Bold-d77fdaed9ae45271626360b29474b598.woff";